module.exports = __webpack_public_path__ + "img/brand_img.e82b2723.png";